import React from 'react'
import { Card, Tag, Tooltip } from 'antd'
import { safe, shortDate, getDaysSinceComplaint, isExpectedCompletionPast, hslToRgb, getPresentStatusColor } from './utils'
import './styles.css'
import moment from 'moment'

function JobCard({ card, onClick }) {
  const isDark = typeof document !== 'undefined' && document.body && document.body.classList.contains('dark-theme')
  const isUnserviceable = (card.assetUnservicable || '').toString().toLowerCase().trim() === 'true'
  const daysSinceComplaint = getDaysSinceComplaint(card)
  const expectedDate = card.expectedCompletion ? shortDate(card.expectedCompletion) : ''
  const isPastDue = isExpectedCompletionPast(card)

  // Get present status color
  const statusColor = (card.presentStatusColor && card.presentStatusColor.trim())
    ? card.presentStatusColor.trim()
    : getPresentStatusColor(card.presentStatus)

  let textColor = '#172b4d'
  if (statusColor) {
    const rgb = hslToRgb(statusColor)
    const brightness = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000
    // console.log('brightness', brightness);
    textColor = brightness > 180 ? '#172b4d' : '#fff'
  }

  const locBits = [safe(card.location)]
  if (safe(card.subLocation) !== '—') locBits.push(safe(card.subLocation))

  const cardBackground = isUnserviceable
    ? (isDark ? '#3b1f1f' : '#ffe5e5')
    : (isDark ? '#111827' : '#FCFCFC')
  const cardShadow = isDark ? '0 1px 3px rgba(0, 0, 0, 0.45)' : '0 1px 3px rgba(9, 30, 66, 0.15)'
  const mutedText = isDark ? '#94a3b8' : '#6b778c'

  return (
    <Card
      className={`job-card ${isUnserviceable ? 'unserviceable' : ''}`}
      onClick={onClick}
      size="small"
      style={{
        marginBottom: '4px',
        cursor: 'pointer',
        backgroundColor: cardBackground,
        borderRadius: '8px',
        boxShadow: cardShadow,
        transition: 'transform 0.1s ease, box-shadow 0.1s ease'
      }}
      bodyStyle={{ padding: '4px 6px' }}
    // hoverable
    >
      <div className="card-top-row">
        <span className="job-id">{safe(card.jobCardNo)}</span>
        {daysSinceComplaint !== null && (
          <Tag color="green" style={{
            fontSize: '9px', padding: '0px 4px',
            borderRadius: '15px', marginRight: '0px', marginLeft: '0px'
          }}>
            {daysSinceComplaint} {daysSinceComplaint === 1 ? 'day' : 'days'}
          </Tag>
        )}
        <Tooltip title={card.expectedCompletion && moment(card.expectedCompletion).format('DD-MM-YYYY') || 'No date'}>
          <Tag
            color="blue"
            style={{
              fontSize: '9px',
              padding: '0px 3px',
              borderRadius: '15px',
              maxWidth: '150px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              cursor: 'pointer',
              marginRight: '0px', marginLeft: '0px',
            }}
          >
            {isPastDue && <span className="sla-badge-past-indicator" />}
            {expectedDate || '—'}
          </Tag>
        </Tooltip>
      </div>

      {card.organisationName && (
        <div className="card-organisation" style={{ fontSize: '10px', color: mutedText, marginBottom: '2px' }}>
          {card.organisationName}
        </div>
      )}

      <div className="card-title">{safe(card.detailsOfComplaint)}</div>

      <div className="card-line">
        <span>{safe(card.assetSubType || card.assetType)}</span>
        <span>{safe(card.assetCode)}</span>
      </div>

      <div className="card-line">
        <span>{locBits.join(' · ')}</span>
        <span>{safe(card.owner)}</span>
      </div>

      {card.presentStatus && (
        <div className="card-tags" style={{ marginTop: '2px' }}>
          <Tag
            style={{
              background: statusColor || '#f4f5f7',
              color: textColor,
              // fontWeight: 'bold',
              fontSize: '10px',
              // padding: '2px 6px',
              borderRadius: '15px'
            }}
          >
            {card.presentStatus}
          </Tag>
        </div>
      )}

      <div className="card-footer">
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <span>{safe(card.complaintNo)}</span>
          <span>{shortDate(card.complaintDate)}</span>
        </div>
        <div style={{ width: '100%', textAlign: 'right' }}>
          <span style={{ fontWeight: 'bold' }}>Review: {shortDate(card.reviewDate)}</span>
        </div>
      </div>
    </Card>
  )
}

export default JobCard
